import cx from 'classnames';
import { EMPTY_CHIP_COLOR } from '.';
import { setAlpha } from '../../../design-tokens';
import { useNCTextLocalizer } from '../../../locale/useNCTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { useColorChipA11yInfo } from './hooks/useColorChipA11yInfo';
import cn from './ColorChips.css.json';
import './ColorChips.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColorChips = props => {
  const localize = useNCTextLocalizer('ColorPicker');
  let styleClassName;
  if (props.type === 'nocolor') {
    styleClassName = cn.noColor;
  } else if (props.type === 'automatic') {
    styleClassName = cn.automatic;
  } else if (props.color === EMPTY_CHIP_COLOR) {
    styleClassName = cn.emptyChip;
  } else if (props.type === 'custom') {
    styleClassName = cn.customColorchip;
  } else {
    styleClassName = cn.colorchip;
  }
  const dt = useDesignTokens();
  const tokens = {
    bd: 'transparent',
    'hover-bd': setAlpha(dt.tokens['color-container-border-4'], 0.5),
    'swatch-bd': dt.tokens['color-neutral'],
    'swatch-bd-width': dt.tokens['size-border-width-s'],
    'empty-bg': 'transparent',
    'inner-bd': dt.tokens['color-container-border-4'],
    'no-color-mark': dt.tokens['color-status-border-alert'],
    padding: dt.tokens['space-base-xxs'],
    'focus-outline-offset': 'calc(-1 * var(--focus-width))'
  };
  const styles = renderInlineCssVars(tokens, 'colorchip');
  const shouldRenderAutomaticSwatch = props.type === 'automatic' && !!props.renderAutomaticSwatch;
  const tabIndex = ['automatic', 'nocolor'].includes(props.type) || props.selected || props.focusable ? 0 : -1;
  const {
    ariaLabel,
    title,
    ariaHidden
  } = useColorChipA11yInfo({
    color: props.color,
    type: props.type
  });
  const onKeyDown = event => {
    if (['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      props.onPress?.(props.color, props.type);
    }
  };
  const onClick = event => {
    event.stopPropagation();
    if (props.color !== EMPTY_CHIP_COLOR && props.onPress) {
      shouldRenderAutomaticSwatch ? props.onPress('#000000', 'automatic') : props.onPress(props.color, props.type);
    }
  };
  const MultiColorSwatchComponent = props.renderAutomaticSwatch ? props.renderAutomaticSwatch({
    getAttributes() {
      let multiColorArialabel = `${localize('automatic.label')}, ${localize('multipleSmallCaseColors.label')}`;
      if (props.selected) {
        multiColorArialabel = localize('basicTab.selected.aria', {
          ariaLabel: multiColorArialabel
        });
      }
      const multiColorTitle = localize('multipleColors.label');
      return {
        ariaLabel: multiColorArialabel,
        title: multiColorTitle
      };
    }
  }) : null;
  return /*#__PURE__*/_jsx("div", {
    role: "button",
    tabIndex: tabIndex,
    style: styles,
    onClick: onClick,
    onKeyDown: onKeyDown,
    "aria-hidden": ariaHidden,
    "data-testid": postfixTestId(props.testId, `${props.type}-${props.color}`),
    className: cx(styleClassName, props.selected && !props.tabToStandardBlock && cn.selected),
    ...(!shouldRenderAutomaticSwatch && {
      title,
      'aria-label': ariaLabel ? props.selected ? localize('basicTab.selected.aria', {
        ariaLabel
      }) : ariaLabel : undefined
    }),
    children: shouldRenderAutomaticSwatch ? MultiColorSwatchComponent : /*#__PURE__*/_jsx("span", {
      className: cx(`${styleClassName}-inner`, (props.color === '#FFFFFF' && dt.themeVariant !== 'high-contrast' || props.color === '#000000' && dt.themeVariant !== 'light') && cn.visibleInnerBorder),
      style: {
        backgroundColor: props.color,
        ...props.style
      }
    })
  });
};
//# sourceMappingURL=ColorChips.js.map